module.exports = __webpack_public_path__ + "static/media/popup-check.f1bf1747.png";